'use client';

import { useState } from 'react';

import { TailwindScreenIndicator } from './tailwind-screen-indicator';

export function DevTools() {
    const [grid, setGrid] = useState(false);

    if (process.env.NODE_ENV !== 'development') return null;

    return (
        <>
            <div className='fixed right-1 bottom-1 z-50 flex gap-1'>
                <TailwindScreenIndicator />

                <button
                    className='grid h-6 cursor-pointer place-content-center rounded bg-gray-800 px-2 font-mono text-xs/1 text-white uppercase opacity-30 select-none hover:opacity-100'
                    onClick={() => setGrid(!grid)}>
                    Grid
                </button>
            </div>

            {grid && (
                <div className='animate-in fade-in pointer-events-none fixed top-0 left-0 z-50 flex h-dvh w-full justify-center opacity-20 duration-500'>
                    <div className='container h-full'>
                        <div className='page-grid h-full text-center'>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                            <div className='h-full bg-[hotpink]'></div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
